import { render, Suspense } from "@wordpress/element";
import withAppProviders from "withAppProviders";
import Block from "./Block";

const EventsFrontend = ({ attributes }) => {
	return <Block attributes={attributes} />;
};

const Events = withAppProviders(EventsFrontend)();
export default Events;

window.addEventListener("DOMContentLoaded", () => {
	const element = document.querySelector(".wp-block-vino-wine-events");
	if (element) {
		render(
			<Suspense fallback={<div className="wp-block-placeholder" />}>
				<Events />
			</Suspense>,
			element
		);
	}
});
